import { KpiCard, type KpiItem } from "./kpi-card";
import { Skeleton } from "../ui/skeleton";

/**
 * Statik KPI to'ri — avvalgi aylanadigan karusel o'rniga.
 *
 * Karusel har 5 soniyada aylanib, 9 ta o'lchovdan 4 tasini ko'rsatardi: ega
 * biznesini bir qarashda hech qachon ko'ra olmasdi. To'r hammasini birdan
 * beradi va hech narsa harakatlanmaydi (`prefers-reduced-motion` muammosi ham
 * o'z-o'zidan yo'qoladi).
 */
export function KpiGrid({ items }: { items: KpiItem[] }) {
  if (items.length === 0) return null;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-5 gap-2.5 sm:gap-3">
      {items.map(({ key, ...card }) => (
        <KpiCard key={key} {...card} id={key} />
      ))}
    </div>
  );
}

export function KpiGridSkeleton({ count }: { count: number }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-5 gap-2.5 sm:gap-3">
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} className="h-[104px] sm:h-[124px]" />
      ))}
    </div>
  );
}
